import { render } from "./ModalConfirm.vue?vue&type=template&id=3bd99b72&scoped=true"
import script from "./ModalConfirm.vue?vue&type=script&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&lang=js"

import "./ModalConfirm.vue?vue&type=style&index=0&id=3bd99b72&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd99b72"]])

export default __exports__